import { createSelector } from "reselect";

const getUserPaymentViewDetails = (state: any) => state.getIn([ 'paymentFlowReducer', 'userPaymentDetailView' ]);
const getTotalAmount = (state: any) => state.getIn([ 'paymentFlowReducer', 'totalValidOrdersAmount' ]);
const getLoopBackUrl = (state: any) => state.getIn([ 'paymentFlowReducer', 'loopBackURL' ]);

const PaymentViewSelector = createSelector(
  [ getUserPaymentViewDetails, getTotalAmount, getLoopBackUrl ],
  (
    userPaymentDetailView,
    totalValidOrdersAmount,
    loopBackURL
  ) => ({
    userPaymentDetailView,
    totalValidOrdersAmount,
    loopBackURL
  })
);
export default PaymentViewSelector;